import { Button, Col, Form, Input, message, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import pageWarehouseService from '../services/mypageWare';
import Popup from '@root/core/components/Popup';

const Paypal = () => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [val, setVal] = useState({} as object);

  const getData = (value: any) => {
    setOpen(true);
    setVal(value);
  };

  const handleEdit = async () => {
    try {
      setLoading(true);
      await pageWarehouseService.postPaypal(val);
      setLoading(false);
      message.success('Register paypal success!');
    } catch (error: any) {
      setLoading(false);
      const { data } = error?.response;
      if (data && data?.message) {
        message.error(data?.message[0]);
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <Spin spinning={loading}>
      <div className="wrapPayPal">
        <Form onFinish={getData} layout="vertical">
          <Row style={{ marginBottom: '20px' }}>
            <Col span={8}>
              <Form.Item
                label=" Client ID"
                name="clientId"
                rules={[
                  {
                    required: true,
                    message: 'Please input client Id'
                  }
                  // {
                  //   max: 20,
                  //   message: 'Value should be less than 20 character'
                  // }
                ]}
              >
                <Input
                  className="border-input"
                  placeholder="Please enter your PayPal client ID."
                />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ paddingBottom: '10px' }}>
            <Col span={8}>
              <Form.Item
                label="Secret code"
                name="clientSecret"
                rules={[
                  {
                    required: true,
                    message: 'Please input Secret code'
                  }
                  // {
                  //   max: 20,
                  //   message: 'Value should be less than 20 character'
                  // }
                ]}
              >
                <Input
                  className="border-input"
                  placeholder="Please enter your PayPal account secret code."
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Button htmlType="submit">Register</Button>
            </Col>
          </Row>
        </Form>

        <div className="guideline">
          <div className="infoGui">
            {' '}
            <span>💡Guidelines</span>
            <p>
              Please update your PayPal account to your business account in
              order to use the settlement function. <br />
              Press <span style={{ fontWeight: 'bold' }}>
                go to paypal
              </span>{' '}
              button for detailed settings.
            </p>
          </div>

          <div className="goPayPal">
            <Button type="link" href="https://www.paypal.com" target="_blank">
              Go to PayPal
            </Button>
          </div>
          {/* </div> */}
        </div>
      </div>

      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        visible={open}
        title="Do you want to regist the code?"
        text="Please check the information below after registeration."
        action_oke={() => {
          handleEdit();
          setOpen(false);
        }}
        action_cancel={() => setOpen(false)}
      />
    </Spin>
  );
};

export default Paypal;
